<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  options: { type: Array, required: true },
  selected: { type: String, required: true },
  value: { type: [String, Number], required: true },
  supportsValue: { type: Boolean, default: false },
  requiresValue: { type: Boolean, default: false },
  invalidValue: { type: Boolean, default: false },
});
defineEmits(['update:selected', 'update:value']);
const { t } = useI18n();
</script>

<template>
  <!-- seletor de evento -->
  <label class="text-xs text-n-slate-10">
    {{ t('META_CAPI.BOX.EVENT_FIELD') }}
  </label>
  <select
    :value="selected"
    class="w-full px-3 py-2 text-sm rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:ring-2 focus:ring-n-brand/40"
    @change="$emit('update:selected', $event.target.value)"
  >
    <option v-for="ev in options" :key="ev.name" :value="ev.name">
      {{ t(`META_CAPI.EVENTS.${ev.key}`) }}
    </option>
  </select>

  <!-- valor (só p/ eventos que aceitam) -->
  <input
    v-if="supportsValue"
    :value="value"
    type="number"
    min="0"
    step="0.01"
    :required="requiresValue"
    :aria-invalid="invalidValue"
    :placeholder="
      t(
        requiresValue
          ? 'META_CAPI.BOX.PURCHASE_VALUE_PLACEHOLDER'
          : 'META_CAPI.BOX.VALUE_PLACEHOLDER'
      )
    "
    class="w-full px-3 py-2 text-sm rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:ring-2 focus:ring-n-brand/40"
    @input="$emit('update:value', $event.target.value)"
  />

  <p v-if="invalidValue" class="text-xs text-n-ruby-11">
    {{ t('META_CAPI.BOX.PURCHASE_VALUE_REQUIRED') }}
  </p>
</template>
